import axios from "axios";
import baseURL from "./../api";
class UserService {
    getloggedInUserDetails() {
        return axios.get(`${baseURL}/user`);
    }
    updateUserProfile(data) {
        return axios.patch(`${baseURL}/user`,data);
    }

    changePassword(data) {
        return axios.patch(`${baseURL}/user/change-password`,data);
    }

    getSuperviors() {
        return axios.get(`${baseURL}/config/drop-down/supervisors`);
    }

    getRoles() {
        return axios.get(`${baseURL}/config/drop-down/roles`);
    }

    getUsers() {
        return axios.get(`${baseURL}/users`);
    }

    saveUser(data) {
        return axios.post(`${baseURL}/user`, data);
    }
    getUserDetails( id) {
        return axios.get(`${baseURL}/user/${id}`);
    }
    updateUser(id, data) {
        return axios.patch(`${baseURL}/user/${id}`, data);
    }

    deleteUser(id) {
        return axios.delete(`${baseURL}/user/${id}`);
    }

    suspendUser(data) {
        return axios.post(`${baseURL}/user/suspend/multi`,data);
    }

    resumeUser(data) {
        return axios.post(`${baseURL}/user/resume/multi`,data);
    }

    getTotalBalance() {
        return axios.get(`${baseURL}/config/balance`);

    }


}

export default new UserService();